import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appAlphaNumericOnly]'
})
export class AlphaNumericOnlyDirective {
  @Output() appAlphaNumericOnlyChange = new EventEmitter<string>();

  constructor(private elementRef: ElementRef<HTMLInputElement>) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown',
      'Home', 'End', 'PageUp', 'PageDown', 'Insert',
      'Shift', 'Control', 'Alt', 'Meta', 'CapsLock'
    ];

    if (
      allowedKeys.includes(event.key) ||
      /^[A-Za-z0-9]$/.test(event.key) ||
      event.ctrlKey || event.metaKey || event.altKey || event.isComposing ||
      event.key === 'Process' || event.key === 'Unidentified'
    ) {
      return;
    }

    event.preventDefault();
  }

  @HostListener('input')
  onInput(): void {
    const input = this.elementRef.nativeElement;
    const originalValue = input.value;
    const selectionStart = input.selectionStart ?? originalValue.length;
    const selectionEnd = input.selectionEnd ?? selectionStart;
    const filteredValue = this.filterValue(originalValue);
    const value = input.maxLength < 0 ? filteredValue : filteredValue.slice(0, input.maxLength);

    if (originalValue !== value) {
      const nextSelectionStart = Math.min(this.filterValue(originalValue.slice(0, selectionStart)).length, value.length);
      const nextSelectionEnd = Math.min(this.filterValue(originalValue.slice(0, selectionEnd)).length, value.length);
      input.value = value;
      input.setSelectionRange(nextSelectionStart, nextSelectionEnd);
    }

    this.appAlphaNumericOnlyChange.emit(value);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();

    const input = this.elementRef.nativeElement;
    const pastedText = this.filterValue(event.clipboardData?.getData('text/plain') || '');
    const selectionStart = input.selectionStart ?? 0;
    const selectionEnd = input.selectionEnd ?? 0;
    const currentLengthWithoutSelection = input.value.length - (selectionEnd - selectionStart);
    const availableLength = input.maxLength < 0
      ? pastedText.length
      : Math.max(input.maxLength - currentLengthWithoutSelection, 0);

    input.setRangeText(pastedText.slice(0, availableLength), selectionStart, selectionEnd, 'end');
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  private filterValue(value: string): string {
    return value.replace(/[^A-Za-z0-9]/g, '');
  }
}
